module.exports = __webpack_public_path__ + "7213c045f494ffdc530ef4aea3c1f2c4.png";